// ── Autenticazione verso le Edge Functions ──
//
// Le Edge Functions di Supabase rifiutano le richieste senza un token
// valido (verify_jwt attivo). Il gioco usa axios "nudo" in una ventina
// di punti: invece di toccarli tutti, un interceptor aggiunge la chiave
// anon solo alle chiamate dirette al nostro backend.
//
// La chiave anon e' pubblica per definizione — sta gia' nel bundle per
// il realtime — quindi non aggiunge nessuna esposizione.

import axios from 'axios';

const BACKEND = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const ANON = process.env.REACT_APP_SUPABASE_KEY;

axios.interceptors.request.use((config) => {
  const url = config.url || '';
  const isOurs = BACKEND && url.startsWith(BACKEND);
  if (isOurs && ANON && !config.headers?.Authorization) {
    config.headers = { ...config.headers, Authorization: `Bearer ${ANON}`, apikey: ANON };
  }
  return config;
});

export default axios;
